import { actions } from './actions'

const initialState = {
  comboSvg: {
    data: null,
    loading: false,
    error: '',
  },
  combosSvg: {
    data: [],
    loading: false,
    error: '',
  },
  combosSvgByProducto: {
    data: [],
    loading: false,
    error: '',
  },
  comboSvgProducto: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function comboSvgProductoReducer(state = initialState, action) {
  switch (action.type) {
    case actions.COMBOSVG_FILTERED_LOAD_REQUESTED:
      return {
        ...state,
        combosSvg: { ...state.combosSvg, data: null, loading: true },
      }
    case actions.COMBOSVG_FILTERED_LOAD_SUCCEEDED:
      return {
        ...state,
        combosSvg: {
          ...state.combosSvg,
          data: action.payload,
          loading: false,
        },
      }
    case actions.COMBOSVG_FILTERED_LOAD_FAILED:
      return {
        ...state,
        combosSvg: {
          ...state.combosSvg,
          loading: false,
          error: action.error,
        },
      }
    case actions.DELETE_COMBOSVG_REQUESTED:
      return {
        ...state,
        combosSvg: { ...state.combosSvg, loading: true },
      }
    case actions.DELETE_COMBOSVG_SUCCEEDED: {
      return {
        ...state,
        combosSvg: {
          ...state.combosSvg,
          data: state.combosSvg.data.filter(d => action.payload !== d.id),
          loading: false,
          reload: false,
        },
      }
    }
    case actions.DELETE_COMBOSVG_FAILED:
      return {
        ...state,
        combosSvg: {
          ...state.combosSvg,
          loading: false,
          error: action.error,
        },
      }
    case actions.COMBOSVG_UPDATE_REQUESTED:
      return {
        ...state,
        combosSvg: { ...state.combosSvg, loading: true, error: '' },
        comboSvg: { ...state.comboSvg, loading: true, error: '' },
      }
    case actions.COMBOSVG_UPDATE_SUCCEEDED:
      return {
        ...state,
        combosSvg: {
          data: [...state.combosSvg.data.filter(b => b.id !== action.payload.id), action.payload],
          loading: false,
          error: '',
        },
        comboSvg: {
          ...state.comboSvg,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.COMBOSVG_UPDATE_FAILED:
      return {
        ...state,
        comboSvg: {
          ...state.combosSvg,
          loading: false,
          error: action.error,
        },
      }
    case actions.COMBOSVG_INSERT_REQUESTED:
      return {
        ...state,
        combosSvg: { ...state.combosSvg, loading: true, error: '' },
      }
    case actions.COMBOSVG_INSERT_SUCCEEDED:
      return {
        ...state,
        combosSvg: {
          data: [...state.combosSvg.data, action.payload],
          loading: false,
          error: '',
        },
      }
    case actions.COMBOSVG_INSERT_FAILED:
      return {
        ...state,
        combosSvg: {
          ...state.combosSvg,
          loading: false,
          error: action.error,
        },
      }
    case actions.COMBOSVG_BYID_LOAD_REQUESTED:
      return {
        ...state,
        comboSvg: { ...state.comboSvg, loading: true, error: '' },
      }
    case actions.COMBOSVG_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        comboSvg: {
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.COMBOSVG_BYID_LOAD_FAILED:
      return {
        ...state,
        comboSvg: {
          ...state.comboSvg,
          loading: false,
          error: action.error,
        },
      }
    case actions.COMBOS_SVG_PRODUCTO_UPDATE_REQUESTED:
      return {
        ...state,
        combosSvgByProducto: {
          ...state.combosSvgByProducto,
          loading: true,
          error: '',
        },
      }
    case actions.COMBOS_SVG_PRODUCTO_UPDATE_SUCCEEDED:
      return {
        ...state,
        combosSvgByProducto: {
          ...state.combosSvgByProducto,
          data: [...action.payload],
          loading: false,
          error: '',
        },
      }
    case actions.COMBOS_SVG_PRODUCTO_UPDATE_FAILED:
      return {
        ...state,
        combosSvgByProducto: {
          ...state.combosSvgByProducto,
          loading: false,
          error: action.error,
        },
      }
    case actions.COMBOSVG_BY_PRODUCTO_ID_LOAD_REQUESTED:
      return {
        ...state,
        combosSvgByProducto: {
          ...state.combosSvgByProducto,
          data: null,
          loading: true,
        },
      }
    case actions.COMBOSVG_BY_PRODUCTO_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        combosSvgByProducto: {
          ...state.combosSvgByProducto,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.COMBOSVG_BY_PRODUCTO_ID_LOAD_FILED:
      return {
        ...state,
        combosSvgByProducto: {
          ...state.combosSvgByProducto,
          loading: false,
          error: action.error,
        },
      }
    case actions.COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_REQUESTED:
      return {
        ...state,
        comboSvgProducto: { ...state.comboSvgProducto, loading: true, error: '' },
      }
    case actions.COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        comboSvgProducto: {
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_FILED:
      return {
        ...state,
        comboSvgProducto: {
          ...state.comboSvgProducto,
          loading: false,
          error: action.error,
        },
      }
    case actions.COMBOSVG_PRODUCTO_UPDATE_REQUESTED:
      return {
        ...state,
        comboSvgProducto: { ...state.comboSvgProducto, loading: true, error: '' },
      }
    case actions.COMBOSVG_PRODUCTO_UPDATE_SUCCEEDED:
      return {
        ...state,
        comboSvgProducto: {
          ...state.comboSvgProducto,
          data: action.payload,
          loading: false,
          error: '',
        },
        combosSvgByProducto: {
          data: [
            ...state.combosSvgByProducto.data.filter(
              b => b.comboSvgId !== action.payload.comboSvgId,
            ),
            action.payload,
          ],
          loading: false,
          error: '',
        },
      }
    case actions.COMBOSVG_PRODUCTO_UPDATE_FAILED:
      return {
        ...state,
        comboSvgProducto: {
          ...state.combosSvg,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
